import { Location } from 'react-router-dom';
import {
  CreateJobPostStep1Icon,
  CreateJobPostStep2Icon,
  CreateJobPostStep3Icon,
  CreateJobPostStep4Icon,
  CreateJobPostStep5Icon,
} from 'assets';

export const getLeftBlockIcon = (location: Location) => {
  switch (location.pathname) {
    case '/create-job-post/step1':
      return <CreateJobPostStep1Icon />;
    case '/create-job-post/step2':
      return <CreateJobPostStep2Icon />;
    case '/create-job-post/step3':
      return <CreateJobPostStep3Icon />;
    case '/create-job-post/step4':
      return <CreateJobPostStep4Icon />;
    case '/create-job-post/step5':
      return <CreateJobPostStep5Icon />;
    default:
      return null;
  }
};
